import React from 'react';
import { FormBuilder } from 'commons-ui';
import useCreate from './useCreate';
import { FORM_FIELD_CONFIG, FORM_LAYOUT_CONFIG, validationSchemaCreate } from '../../utils/formConfig';

const CreateCoupon: React.FC<{}> = () => {
	const { data, showLoader, handleFormSubmit, handleFormCancel, setShowLoader } = useCreate();

	return (
		<FormBuilder
			data={data}
			mode='create'
			showLoader={showLoader}
			handleFormSubmit={handleFormSubmit}
			handleFormCancel={handleFormCancel}
			validationSchema={validationSchemaCreate}
			setShowLoader={setShowLoader}
			fieldConfig={FORM_FIELD_CONFIG}
			layoutConfig={FORM_LAYOUT_CONFIG}
		/>
	);
};

export default CreateCoupon;
